import { Validator } from '@vista-digital/validator';
export const defaultOccFormDisplayText = {
    fieldOptionalSuffix: ' (optional)',
    passwordRuleCheckerHelpText: 'Password must contain:',
    submitButtonLabel: 'Submit',
    cancelButtonLabel: 'Cancel',
    emailSuggestionFormat: 'Did you mean ${suggestedEmail}?'
};
export const occFormDisplayTextValidator = Validator.object({
    fieldOptionalSuffix: Validator.nonEmptyString,
    passwordRuleCheckerHelpText: Validator.nonEmptyString,
    submitButtonLabel: Validator.nonEmptyString,
    cancelButtonLabel: Validator.nonEmptyString,
    emailSuggestionFormat: Validator.nonEmptyString
});
//# sourceMappingURL=form.js.map